import { CheckIcon } from '@heroicons/react/24/solid'

const STEP_LABELS = ['Welcome', 'Add Content', 'Preview', 'Customize', 'Install']

export default function ProgressIndicator({ currentStep, totalSteps = 5 }) {
  return (
    <div className="w-full">
      <div className="flex items-center justify-between">
        {Array.from({ length: totalSteps }, (_, i) => {
          const step = i + 1
          const isCompleted = step < currentStep
          const isCurrent = step === currentStep
          const isFuture = step > currentStep

          return (
            <div key={step} className="flex items-center flex-1 last:flex-none">
              {/* Step circle and label */}
              <div className="flex flex-col items-center">
                <div
                  className={`
                    flex items-center justify-center w-10 h-10 rounded-full text-sm font-semibold transition-all
                    ${isCompleted ? 'bg-indigo-600 text-white' : ''}
                    ${isCurrent ? 'border-2 border-indigo-600 text-indigo-600 animate-pulse' : ''}
                    ${isFuture ? 'bg-slate-200 text-slate-500' : ''}
                  `}
                >
                  {isCompleted ? (
                    <CheckIcon className="h-5 w-5" />
                  ) : (
                    step
                  )}
                </div>
                <span
                  className={`
                    mt-2 text-xs font-medium whitespace-nowrap
                    ${isCompleted ? 'text-indigo-600' : ''}
                    ${isCurrent ? 'text-indigo-600' : ''}
                    ${isFuture ? 'text-slate-400' : ''}
                  `}
                >
                  {STEP_LABELS[i]}
                </span>
              </div>

              {/* Connecting line */}
              {step < totalSteps && (
                <div
                  className={`
                    flex-1 h-0.5 mx-2 mb-6
                    ${step < currentStep ? 'bg-indigo-600' : 'bg-slate-200'}
                  `}
                />
              )}
            </div>
          )
        })}
      </div>
    </div>
  )
}
